import clsx from 'clsx'
import type { PropsWithChildren, ReactElement } from 'react'
import { inputLabel, inputLabelSmall } from './TextInput.css'

export const Label = ({
  className,
  children,
  inputSize
}: PropsWithChildren<{
  className?: string
  inputSize?: 'small'
}>): ReactElement => {
  return (
    <label
      className={clsx(
        inputLabel,
        className,
        inputSize === 'small' ? inputLabelSmall : null
      )}
    >
      {children}
    </label>
  )
}
